import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ToastMessageService } from 'src/app/widgets/toast-message/toast-message.service';
import { PHONE_TYPES } from '../../../constants/phone-types';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-sales-account-head-form',
  templateUrl: './sales-account-head-form.component.html',
  styleUrls: ['./sales-account-head-form.component.scss']
})
export class SalesAccountHeadFormComponent implements OnInit {

  @Output() salesAccountSaved: EventEmitter<any> = new EventEmitter();

  // states
  formProcessing = false;

  // errors
  fieldErrors: any = {};
  formErrors: any = null;

  // form model
  model = {
    SalesAccountCode: null,
    CompanyName: null,
    Person: {
      FirstName: null,
      LastName: null,
      CompanyName: null,
      Addresses: [{
        Address1: null,
        Address2: null,
        Address3: null,
        CityName: null,
        StateCode: null,
        PostalCode: null
      }],
      Emails: [{
        EmailAddress: null
      }],
      Phones: [{
        PhoneNumber: null,
        PhoneType: 1,
        PhoneExt: null
      }]
    }
  };

  // menu options data
  phoneTypes = PHONE_TYPES;

  // endpoint
  salesAccountEp = `${this.apiSvc.endpoints.sales}/api/SalesAccount`;

  constructor(
    private apiSvc: ApiService,
    private toastMsgSvc: ToastMessageService
  ) { }

  ngOnInit() {
  }

  onSubmit(e: any, form: object): void {

    e.preventDefault();

    // if form is invalid, return
    if (!form['valid'] || this.formProcessing) {
      return;
    }

    this.formProcessing = true;
    this.fieldErrors = {};
    this.formErrors = null;

    const payload = JSON.parse( JSON.stringify(this.model) );

    const email = this.model.Person.Emails[0].EmailAddress;

    if (email === null || email === '') {
      payload['Person']['Emails'] = null;
    }

    const phone = this.model.Person.Phones[0].PhoneNumber;
    if (phone === null || phone === '') {
      payload['Person']['Phones'] = null;
    }

    this.apiSvc.add(this.salesAccountEp, payload)
      .subscribe((res) => {

        this.formProcessing = false;

        this.salesAccountSaved.emit({
          confirm: true,
          account: res
        });

        this.toastMsgSvc.send({
          icon: 'check_circle_outline',
          message: 'Customer account created',
          type: 'success'
        });

      }, (err) => {

        let hasErrors = false;

        if (err['error'] && err['error']['FieldErrors'] && err['error']['FieldErrors'].length > 0) {

          for (const error of err['error']['FieldErrors']) {
            this.fieldErrors[error['Field']] = error['Message'];
          }

          hasErrors = true;

        }

        if (err['error'] && err['error']['Errors']) {
          this.formErrors = err['error']['Errors'];
          hasErrors = true;
        }

        if (!hasErrors) {
          this.formErrors = [{Message: 'There was a problem saving the account.'}];
        }


        this.formProcessing = false;

      });

  }

}
